import { useEffect } from 'react';
import CustomersIcon from './CustomersIcon';

export default function CustomerModal({ title, children, onClose, className = '' }) {
  useEffect(() => {
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const closeOnEscape = event => { if (event.key === 'Escape') onClose(); };
    document.addEventListener('keydown', closeOnEscape);
    return () => { document.body.style.overflow = previous; document.removeEventListener('keydown', closeOnEscape); };
  }, [onClose]);

  return <div className="customers-modal" onMouseDown={onClose}>
    <section className={`customers-modal__box ${className}`} role="dialog" aria-modal="true" aria-label={title} onMouseDown={event => event.stopPropagation()}>
      <header><h2>{title}</h2><button type="button" onClick={onClose} aria-label="بستن"><CustomersIcon name="close" /></button></header>
      {children}
    </section>
  </div>;
}
